import { queryOptions } from '@tanstack/react-query';
import { listSystemsIssues } from './listSystemsIssues.api';

export const listSystemsIssuesQuery = queryOptions({
  queryKey: ['listSystemsIssues'],
  queryFn: listSystemsIssues,
});
